"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_OVERALL_RATING = exports.SORT_ORDER = exports.SORT_FIELD = exports.COLLECTION = exports.SEARCH = exports.SUPPORT_LANGUAGES = exports.SUPPORT_SOURCE = exports.INTEGRATIONS = exports.CERTIFIED = exports.SYNC = exports.HUBSPOT_FEATURES = exports.TIERS = exports.PLAN_COMPATIBLE = exports.PRICING = exports.CATEGORY_FEATURES = exports.SUPER_CATEGORY = exports.CATEGORY = void 0;
var CATEGORY = 'category';
exports.CATEGORY = CATEGORY;
var SUPER_CATEGORY = 'superCategory';
exports.SUPER_CATEGORY = SUPER_CATEGORY;
var CATEGORY_FEATURES = 'categoryFeatures';
exports.CATEGORY_FEATURES = CATEGORY_FEATURES;
var PRICING = 'planType';
exports.PRICING = PRICING;
var PLAN_COMPATIBLE = 'onlyHubInstallable';
exports.PLAN_COMPATIBLE = PLAN_COMPATIBLE;
var TIERS = 'tiers';
exports.TIERS = TIERS;
var HUBSPOT_FEATURES = 'hubSpotFeatures';
exports.HUBSPOT_FEATURES = HUBSPOT_FEATURES;
var SYNC = 'sync';
exports.SYNC = SYNC;
var CERTIFIED = 'onlyCertified';
exports.CERTIFIED = CERTIFIED;
var INTEGRATIONS = 'integrations';
exports.INTEGRATIONS = INTEGRATIONS;
var SUPPORT_SOURCE = 'supportSource';
exports.SUPPORT_SOURCE = SUPPORT_SOURCE;
var SUPPORT_LANGUAGES = 'supportLanguages';
exports.SUPPORT_LANGUAGES = SUPPORT_LANGUAGES;
var SEARCH = 'search';
exports.SEARCH = SEARCH;
var COLLECTION = 'collection';
exports.COLLECTION = COLLECTION;
var SORT_FIELD = 'sortField';
exports.SORT_FIELD = SORT_FIELD;
var SORT_ORDER = 'sortOrder';
exports.SORT_ORDER = SORT_ORDER;
var MIN_OVERALL_RATING = 'minOverallRating';
exports.MIN_OVERALL_RATING = MIN_OVERALL_RATING;


//////////////////
// WEBPACK FOOTER
// ./js/constants/search/FilterKey.js
// module id = 43
// module chunks = 209 210 211 212 213